module.exports = __webpack_public_path__ + "img/northern-ireland.2.4c6108d.jpg";